import { observer } from 'mobx-react';
import refundLogStore from '~/view/screens/RefundLogScreen/screens/RefundLog/store/refundLogStore';
import { reportsStore } from '~/view/screens/ReportsScreen/store/reportsStore';
import ReportsCalendar from '~/view/screens/ReportsScreen/components/ReportsCalendar/ReportsCalendar';
import Button from '~/view/components/Controls/ButtonComponent/Button';
import { localeStore } from '~/mobx/localesStore';
import { LoadingStatus } from '~/types/main';

const RefundLogHeader = (): JSX.Element => {
  const onSelectDate = () => {
    refundLogStore.setFilters({ startDate: reportsStore.filters.startDate, endDate: reportsStore.filters.endDate });
  };

  return (
    <div className="d-flex flex-row justify-content-between pr-4">
      <div className="d-flex flex-row">
        <ReportsCalendar startDate={reportsStore.filters.startDate} endDate={reportsStore.filters.endDate} onSelectDate={onSelectDate} />
      </div>
      <div className="d-flex gap-10">
        {refundLogStore.isHasData ? (
          <Button
            title={localeStore.t('export_to_excel')}
            onClick={refundLogStore.export}
            loading={refundLogStore.exportLoadingStatus === LoadingStatus.Loading}
            appearance="secondary"
          />
        ) : null}
      </div>
    </div>
  );
};

export default observer(RefundLogHeader);
